import { render, staticRenderFns } from "./BusinessProofPreviewPopup.vue?vue&type=template&id=234c0df4&"
import script from "./BusinessProofPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./BusinessProofPreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports